import { useEffect, useState } from "react"
import { EventInfo } from "../types"
import { Container, Wrap } from "@chakra-ui/react"
import axios from "axios"
import RSVPCardComponent from "./rsvp-card-component"
import RSVPComponent from "./rsvp-component"
import useMeasure from 'react-use-measure'
import { api_url } from "@/variables"

const UserComponent = () => { 
    const [events, setEvents] = useState<EventInfo[] | null>(null)
    const [showEvents, setShowEvents] = useState<boolean>(true)

    const [wrapRef, bounds] = useMeasure()

    //get events
    useEffect(() => {
        const getEvents = async () => {
            const response = await axios.get(`${api_url}/events`)

            setEvents(response.data)
        }
        getEvents()
    }, [])

    const toggleShowEvents = () => {
        setShowEvents(!showEvents)
    }

    return (
        <>
        <Container bg="grackle.700" 
            style={{margin: "auto"}}>
            { showEvents ? "Upcoming events" : "RSVP" }
        </Container>
        { !showEvents && 
            <Container bg="grackle.500" color="grackle.900" style={{margin: "auto"}}>
                &nbsp;&nbsp;<a href="#" onClick={() => toggleShowEvents()}>{`${"<<"} Back to Events`}</a>
            </Container>
        }
        { events == null ?
            <i>Loading events...</i>
        :
        events.length == 0 ?
            <i>No events to display.</i>
            :
            <Wrap gap="2" style={{margin: "auto", width: "90%"}} ref={wrapRef}>
                { showEvents && 
                    events.map((e: EventInfo) =>  
                        <RSVPCardComponent event={e} updateFn={toggleShowEvents} />
                    )   
                }
            </Wrap>
        }
        { !showEvents &&
            <RSVPComponent 
                parentWidth={bounds.width}
                iframeSrc={`https://docs.google.com/forms/d/e/1FAIpQLSeVCt2_IGG-IasY_YlmgcQDQet2trI4rnRNjyjti37SShc4MQ/viewform?embedded=true`}
            />  
        }
        </>
    )
}

export default UserComponent